import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'react-redux-firebase';
import { generatePath } from 'react-router-dom';
import { ROUTES_MAP } from '../config/routes';

const getRequiredPathParams = (path = '') => {
  return path
    .split('/')
    .filter((segment) => segment.startsWith(':'))
    .map((segment) => segment.replace(':', ''));
};

export default function useRedirect(redirect) {
  const [redirectTo, setRedirectTo] = useState(ROUTES_MAP.NOT_AUTHED.path);
  const ids = useSelector((state) => state.params.ids);

  useEffect(() => {
    if (!redirect || isEmpty(ids)) {
      return;
    }

    const requiredParams = getRequiredPathParams(redirect);
    const missingRequiredParam = requiredParams.some(
      (param) =>
        ids[param] === undefined || ids[param] === null || ids[param] === '',
    );

    if (missingRequiredParam) {
      return;
    }

    setRedirectTo(generatePath(redirect || '', ids));
  }, [redirect, ids]);
  return redirectTo;
}
